import ExamImageComponent from '../ExamImageComponent';
import SheetCorrectionHeader from './SheetCorrectionHeader';
import SheetCorrectionLayer from './SheetCorrectionLayer';
import SheetCorrectionProvider from './SheetCorrectionProvider';

function ExamImageSheetCorrectionField(props) {
	return (
		<SheetCorrectionProvider>
			<ExamImageComponent {...props} HeaderComponent={SheetCorrectionHeader} LayerComponent={SheetCorrectionLayer} />
		</SheetCorrectionProvider>
	);
}

export default ExamImageSheetCorrectionField;
